import { render, staticRenderFns } from "./TextPanel.vue?vue&type=template&id=219a173e&scoped=true&"
import script from "./TextPanel.vue?vue&type=script&lang=js&"
export * from "./TextPanel.vue?vue&type=script&lang=js&"
import style0 from "./TextPanel.vue?vue&type=style&index=0&id=219a173e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../abbreviation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219a173e",
  null
  
)

export default component.exports